var _style, _defs, _path, _path2, _path3, _path4, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 93.2 29",
    style: {
      enableBackground: "new 0 0 93.2 29"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{display:inline;clip-path:url(#SVGID_00000021823618609391702160000011147081964345600439_);}\r\n\t.st3{fill:#EF3F3B;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#0040BF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.1,
    width: 92.9,
    height: 29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048479316721202903650000014140289969272200081_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000048479316721202903650000014140289969272200081_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.9,26.3v-9.7H5v9.7H0.1V3.3H5v9.1h10.9V3.2h5v23.1L15.9,26.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.3,14.8c0-7,5.1-11.9,12-11.9c7,0,12.1,5,12.1,11.9c0,7-5.1,11.9-12.1,11.9C29.4,26.7,24.3,21.8,24.3,14.8 z M43.3,14.8c0-4.3-2.8-7.6-7-7.6s-7,3.3-7,7.6c0,4.3,2.7,7.6,7,7.6S43.3,19.1,43.3,14.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.4,26.3V7.6h-6.8V3.2H68v4.3h-6.7v18.8H56.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.7,0C77,0,72.5,4.9,72.5,10.9c0,4.4,1.4,5.6,9.2,17.5c0.5,0.8,1.6,0.8,2.1,0C91.5,16.5,93,15.2,93,10.9 C93,4.9,88.4,0,82.7,0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86.8,13.1c-1.1,2.3-3.9,3.2-6.1,2c-2.3-1.1-3.2-3.9-2-6.1l2.1-4.1l0.4,0.2c0.1,0.1,0.2,0.2,0.3,0.3 c0.9,0.7,1.6,1.4,2.2,2.3c1.1,1.8,1,3,1.4,3c0.4,0,1-1,1.4-2.3C87.4,9.9,87.5,11.7,86.8,13.1z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0,26V3.2h4.9v9h9.5v-9h4.9V26h-4.9v-10H4.9v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.2,26V3.2h17.8v3.9h-13v5.1h12.1V16H29.1v6.2h13.4V26H24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.7,26V3.2h10.2c2.6,0,4.4,0.2,5.6,0.6C63.6,4.2,64.6,5,65.3,6c0.7,1,1,2.2,1,3.6c0,1.7-0.5,3.1-1.6,4.2 C63.7,15,62.1,15.7,60,16c1,0.6,1.9,1.2,2.6,1.9c0.7,0.7,1.6,1.9,2.8,3.7l2.9,4.5h-5.8l-3.5-5c-1.2-1.8-2.1-2.9-2.6-3.4 c-0.5-0.5-0.9-0.8-1.5-0.9s-1.3-0.3-2.4-0.3h-1V26H46.7z M51.5,12.9h3.6c2.3,0,3.8-0.1,4.4-0.3c0.6-0.2,1-0.5,1.4-1 c0.3-0.5,0.5-1,0.5-1.7c0-0.8-0.2-1.4-0.6-1.9s-1-0.8-1.8-0.9c-0.4-0.1-1.6-0.1-3.5-0.1h-3.8V12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.9,14.8c0-2.3,0.4-4.3,1.1-5.9c0.5-1.2,1.3-2.2,2.2-3.1c0.9-0.9,2-1.6,3.1-2.1c1.5-0.6,3.2-0.9,5.2-0.9 c3.5,0,6.4,1,8.5,3.1c2.1,2.1,3.2,5,3.2,8.7c0,3.7-1.1,6.6-3.2,8.6c-2.1,2.1-4.9,3.1-8.5,3.1c-3.6,0-6.4-1-8.5-3.1 S69.9,18.4,69.9,14.8z M74.9,14.6c0,2.6,0.6,4.5,1.9,5.9c1.3,1.3,2.9,2,4.8,2c1.9,0,3.5-0.7,4.8-2c1.2-1.3,1.9-3.3,1.9-6 c0-2.6-0.6-4.6-1.8-5.9c-1.2-1.3-2.8-1.9-4.8-1.9c-2,0-3.6,0.7-4.8,2C75.5,10,74.9,12,74.9,14.6z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export default ForwardRef;